// test2549
(2549 && 0);
